import React, { useState, useEffect } from 'react'
import MessageBox from '../../components/MessageBox/MessageBox'
import Puzzle from '../../components/Puzzle/Puzzle'
import Alphabet from '../../components/Alphabet/Alphabet'
import Modal from '../../components/UI/Modal/Modal'
import GameSummary from '../../components/GameSummary/GameSummary'

import * as actions from '../../store/actions/index'
import { connect } from 'react-redux'

const Hangman = props => {
  // UI local state
  const [gameEnding, setGameEnding] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const { clickedLetterIndex } = props

  // API call to fetch puzzle phrase
  useEffect(() => {
    props.onSetPuzzle(props.game, props.puzzleWordCount)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Updates game after clicking on a letter
  const clickLetterHandler = (clickedLetterIndex) => {
    if (endGame()) return

    const clickedLetter = props.alphabet[clickedLetterIndex].letter.toLowerCase()

    props.onUpdateAlphabet(clickedLetterIndex)
    props.game.makeGuess(clickedLetter)
    props.onSetCurrentLetter(clickedLetter)
    props.onSetCurrentNumberOfCorrectLetters(props.game.sumOfCorrectLetters(clickedLetter))

    if (props.game.gameStatus === 'failed' || props.game.gameStatus === 'finished') {
      props.onSaveGameToDatabase(props.game, props.correctGuessesCount, props.incorrectGuessesCount)
      props.onUpdateStatusMessage()
      setGameEnding(true)
      setShowModal(true)
    } else {
      props.onUpdateStatusMessage()
    }
  }

  const endGame = () => {
    if (props.game.status !== 'playing') {
      setGameEnding(true)
      setShowModal(true)
      return true
    }
    return false
  }

  const modalClosedHandler = () => {
    setShowModal(false)
  }

  useEffect(() => {
    props.onKeyPress(props.game, props.alphabet)
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (clickedLetterIndex >= 0 && clickedLetterIndex <= 25) {
      clickLetterHandler(clickedLetterIndex)
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickedLetterIndex])

  return (
    <React.Fragment>
      <Modal
        showModal={showModal}
        modalClosed={modalClosedHandler}>
        <GameSummary clicked={modalClosedHandler} />
      </Modal>

      <MessageBox show={gameEnding} />

      <Puzzle puzzle={props.game.puzzle} />

      <Alphabet clicked={clickLetterHandler} />
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {
    game: state.puzzle.game,
    puzzleWordCount: state.puzzle.puzzleWordCount,
    alphabet: state.puzzle.alphabet,
    puzzle: state.puzzle.puzzle,
    correctGuess: state.puzzle.correctGuess,
    correctGuessesCount: state.puzzle.correctGuessesCount,
    incorrectGuessesCount: state.puzzle.incorrectGuessesCount,
    clickedLetterIndex: state.puzzle.clickedLetterIndex
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSetPuzzle: (game, puzzleWordCount) => dispatch(actions.initPuzzle(game, puzzleWordCount)),
    onKeyPress: (game, alphabet) => dispatch(actions.keyPressInit(game, alphabet)),
    onUpdateAlphabet: (clickedLetterIndex) => dispatch(actions.updateAlphabet(clickedLetterIndex)),
    onUpdateStatusMessage: () => dispatch(actions.updateStatusMessage()),
    onSetCurrentLetter: (letter) => dispatch(actions.setCurrentLetter(letter)),
    onSetCurrentNumberOfCorrectLetters: (currentNumberOfCorrectLetters) => dispatch(actions.setCurrentNumberOfCorrectLetters(currentNumberOfCorrectLetters)),
    onSaveGameToDatabase: (game, correctGuessesCount, incorrectGuessesCount) => dispatch(actions.saveGameToDatabase(game, correctGuessesCount, incorrectGuessesCount))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Hangman)
